import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: (rowData: any) => {
					const { deployedAt, deployedBy } = rowData;
					if (deployedAt && deployedBy) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateSubAppUpdateInfo,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].createSubAppUpdateInfo,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Turn off updates',
				id: 'updates_off',
				isEnabled: (rowData: any) => {
					const { updateOff } = rowData;
					if (updateOff) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo]?.updateSubAppUpdateInfo,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Turn on updates',
				id: 'updates_on',
				isEnabled: (rowData: any) => {
					const { updateOff } = rowData;

					if (!updateOff) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo]?.updateSubAppUpdateInfo,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.apkUpdateInfo,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo]?.createSubAppUpdateInfo,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
